import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LoadingController, NavController } from '@ionic/angular';
import { Logger } from '../../util/logger/logger.service';
import { presentLoader } from '../../util/ion-util';
import { AppRoutingUtil } from 'src/app/util/app-routing-util';
import { Auth } from 'aws-amplify';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {

  public error: any;

  form: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingCtrl: LoadingController,
    private logger: Logger,
    private navCtrl: NavController,) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      username: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/)])],
    }, { updateOn: 'blur' });
  }

  $msg: string;
  async onSubmit() {
    this.logger.debug(this.form.value, this.form);

    if (this.form.invalid) {
      this.$msg = 'Please enter the email address you used to sign up with Bluecrew.';
      return this.$msg;
    }

    const loader = await presentLoader(this.loadingCtrl);

    // make sure email is lowercase
    this.form.controls.username.setValue(this.form.value.username.toLowerCase());

    try {
      await Auth.forgotPassword(this.form.value.username);
    } catch (error) {
      // do nothing here to prevent disclosing whether or not the email is in our system
    } finally {
      loader.dismiss();
      await this.navCtrl.navigateForward(AppRoutingUtil.ACCOUNT_FORGOT_PASSWORD_SUBMIT, { replaceUrl: true, queryParams: { username: this.form.value.username }, queryParamsHandling: 'merge' });
    }
  }

}
